<template>
  <div class="hello">
    <h1 class="fs-3">LEVERAGE calculator</h1>
    <form @submit.prevent="submitForm" novalidate>
      <div class="row justify-content-center mt-5">
        <div class="col-4 col-lg-2 my-auto">
          Account value (SGPV)
        </div>
        <div class="col-8 col-lg-2">
          <div class="input-group">
            <input class="form-control form-control-sm" v-model="form.security_gross_position_value" @keyup="submitForm()" type="number"/>
            <span class="input-group-text" id="basic-addon1">EUR</span>
          </div>

        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-4 col-lg-2 my-auto">
          Your balance (NLV)
        </div>
        <div class="col-8 col-lg-2">
          <div class="input-group">
            <input class="form-control form-control-sm" v-model="form.net_liquidation_value" @keyup="submitForm()" type="number"/>
            <span class="input-group-text" id="basic-addon1">EUR</span>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-12 col-lg-6 mt-3">
          <p>Actual leverage is: {{current_leverage}}</p>
        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-4 col-lg-2 my-auto">
          Price EUR/USD
        </div>
        <div class="col-8 col-lg-2">
          <input class="form-control form-control-sm" v-model="form.price_eur_usd" @keyup="submitForm()" type="number"/>
        </div>
      </div>
      <div class="row justify-content-center mt-3">
        <div class="col-4 col-lg-2 my-auto">
          Price in USD
        </div>
        <div class="col-8 col-lg-2">
          <div class="input-group">
            <input class="form-control form-control-sm" v-model="form.last_price" @keyup="submitForm()" type="number"/>
            <span class="input-group-text" id="basic-addon1">USD</span>
          </div>
        </div>
      </div>
    </form>
    <div class="row justify-content-center mt-3">
      <div class="col-12 col-lg-6 mt-3 pt-5 border-top">
        <p>To leverage 2.0 you must buy: {{leverage_1}}</p>
        <p>To leverage 2.1 you must buy: {{leverage_2}}</p>
        <p>To leverage 2.2 you must buy: {{leverage_3}}</p>
        <p>To leverage 2.3 you must buy: {{leverage_4}}</p>
        <p>To leverage 2.4 you must buy: {{leverage_5}}</p>
        <p>To leverage 2.5 you must buy: {{leverage_6}}</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'LeverageCalculator',
  data() {
    return {
      form: {
        security_gross_position_value: null,
        net_liquidation_value: null,
        price_eur_usd: null,
        last_price: null
      },
      current_leverage: 0,
      leverage_1: 0,
      leverage_2: 0,
      leverage_3: 0,
      leverage_4: 0,
      leverage_5: 0,
      leverage_6: 0,
    }
  },
  methods: {
    submitForm() {
      if(this.form.security_gross_position_value && this.form.net_liquidation_value) {
        this.current_leverage = Math.round((this.form.security_gross_position_value / this.form.net_liquidation_value) * 100) / 100;
      }
      if(this.form.price_eur_usd && this.form.last_price) {
        this.leverage_1 = this.calculateLeverage(2.0);
        this.leverage_2 = this.calculateLeverage(2.1);
        this.leverage_3 = this.calculateLeverage(2.2);
        this.leverage_4 = this.calculateLeverage(2.3);
        this.leverage_5 = this.calculateLeverage(2.4);
        this.leverage_6 = this.calculateLeverage(2.5);
      }
    },
    calculateLeverage(leverage) {
      if(this.form.price_eur_usd && this.form.last_price) {
        var target_leverage = this.form.net_liquidation_value * leverage;
        var invest_leverage = target_leverage - this.form.security_gross_position_value;
        var inv = invest_leverage * this.form.price_eur_usd;
        var result = inv / this.form.last_price;
      }
      return Math.round(result * 100) / 100;
    }
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
